
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

class ListItemForAutoUserInput extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            username: this.props.username,
            givenName: this.props.givenName,
            surname: this.props.surname,
            index: this.props.index,
            active: this.props.active
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            username: nextProps.username,
            givenName: nextProps.givenName,
            surname: nextProps.surname,
            index: nextProps.index,
            active: nextProps.active
        });
    }

    // EVENT HANDLERS

    handleMouseDown (mouseEvent) {
        if (mouseEvent.button === 0) {
            this.props.mouseDown(this.state.index);
        }
    }

    handleMouseOver (mouseEvent) { this.props.mouseOver(this.state.index); }

    // RENDER METHOD

    render = () => {
        if (this.state.active) {
            return (
                <li
                    style={{"paddingTop": "3px", "paddingBottom": "3px"}}
                    key={this.props.id}
                    id={this.props.id}
                    className={this.props.classNames}
                    onMouseDown={this.handleMouseDown.bind(this)}
                    onMouseOver={this.handleMouseOver.bind(this)}>
                        {this.state.givenName + ' ' + this.state.surname} &nbsp; ({this.state.username}) &nbsp;
                </li>
            );
        } else {
            return (
                <li
                    style={{"paddingTop": "3px", "paddingBottom": "3px"}}
                    key={this.props.id}
                    id={this.props.id}
                    className={this.props.classNames}
                    onMouseDown={this.handleMouseDown.bind(this)}
                    onMouseOver={this.handleMouseOver.bind(this)}>
                        <s>{this.state.givenName + ' ' + this.state.surname} &nbsp; ({this.state.username}) &nbsp;</s>
                </li>
            );
        }
    }
}

ListItemForAutoUserInput.propTypes = {
    active: PropTypes.bool,
    classNames: PropTypes.string,
    givenName: PropTypes.string,
    id: PropTypes.number,
    index: PropTypes.number,
    mouseDown: PropTypes.func,
    mouseOver: PropTypes.func,
    surname: PropTypes.string,
    username: PropTypes.string
};

export default connect()(ListItemForAutoUserInput);


/** WEBPACK FOOTER **
 ** ./src/app/components/ListItemForAutoUserInput.js
 **/